module.exports = __webpack_public_path__ + "img/plus-square.d6dc15c3.svg";